import { ErrorText } from '@main/core-ui';
import React from 'react';
import { useIntl } from 'react-intl';

import { requiredEnabledAirgapMessages } from './messages';

// TODO: https://linear.app/transcend/issue/WAR-4187 - try to remove this
export const RequiredEnabledAirgap: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <div>
      <ErrorText>
        {formatMessage(requiredEnabledAirgapMessages.enableAirgap)}
      </ErrorText>
    </div>
  );
};
